export default __webpack_public_path__ + "static/media/update_calendar_icon.e5baf37b.svg";